export const RESULT_TYPE = {
  COMBINED_RESULTS: 'COMBINED_RESULTS',
  COMBINED_EXPLORE: 'COMBINED_EXPLORE',
} as const;
